"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tokens_1 = require("../tokens");
var directions = ['top', 'bottom', 'left', 'right'];
var marginProcessor = function (props) {
    var marginProp = props.margin;
    if (!marginProp) {
        return '';
    }
    var margin = marginProp || {};
    var styles = '';
    directions.map(function (direction) {
        if (typeof margin[direction] !== 'undefined') {
            var rawValue = margin[direction];
            var value = void 0;
            if (typeof rawValue === 'string') {
                if (tokens_1.spacing[rawValue]) {
                    value = tokens_1.spacing[rawValue];
                }
                else {
                    value = rawValue;
                }
            }
            else {
                value = rawValue + 'px';
            }
            styles += "margin-" + direction + ": " + value + " !important;";
        }
    });
    return styles;
};
exports.default = marginProcessor;
//# sourceMappingURL=styled-margin.js.map